var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("COM_HeaderNav", { attrs: { mode: "UDMPassCodeIndex" } }),
      _c("MyToolbarVuetify", {
        attrs: { config: _vm.toolbarVuetifyConfig, "grid-meta": _vm.gridMeta },
        on: {
          "add-click": _vm.btnAdd_Click,
          "edit-click": _vm.btnEdit_Click,
          "delete-click": _vm.btnDelete_Click
        }
      }),
      _vm._v(" Ststus (紅/黃色 為特殊色，其他色可以視狀況使用) "),
      _c("span", { staticClass: "badge bg-primary" }, [_vm._v("常")]),
      _vm._v(" 常態使用 "),
      _c("span", { staticClass: "badge bg-success" }, [_vm._v("單")]),
      _vm._v(" 單一使用 "),
      _c("MyGridVuetify", {
        ref: "myGridVuetify",
        attrs: { config: _vm.gridVuetifyConfig, "grid-meta": _vm.gridMeta },
        scopedSlots: _vm._u([
          {
            key: "type",
            fn: function(ref) {
              var item = ref.item
              return [
                item.type === "1" ? _c("p", [_vm._v("常態使用")]) : _vm._e(),
                item.type === "2" ? _c("p", [_vm._v("單一使用")]) : _vm._e()
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }